import Swiper from '../lib/swiper';

class CustomersSlider {
	constructor() {
    this.slider = document.querySelector('.lc-startpage-slider-customers');

    if(this.slider){
      this.initSlider();
    }
  }

  initSlider() {
    this.sliderInstance = new Swiper('.lc-startpage-slider-customers', {
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      loop: true,
      speed: 4000,
      slideClass: 'lc-startpage-item-customer',
      slidesPerView: 'auto',
      spaceBetween: 150,
      effect: 'slide'
    });
  }
} export default CustomersSlider;
